export default {
  number: 'Account number',
  created: 'Open on',
  accounts: 'Accounts',
  alias: 'Alias',
  name: 'Name',
  productId: 'Product',
  addAccount: 'Add account',
  addLimitPackage: 'Add limit package',
  description: 'Description',
  blockAccount: 'Block',
  unblockAccount: 'Unblock',
  closedOn: 'Closed on',
  balances: {
    _: 'Balances',
    accountSummary: 'Account Summary',
    balance: 'Balance',
    amount: 'Amount',
    total: 'Total amount',
  },
  productTemplate: {
    code: {
      USD_CONSUMER_CURRENT_ACCOUNT: 'eMoney Account',
      USD_MERCHANT_CURRENT_ACCOUNT: 'Business eMoney Account',
    },
  },
  noAccounts: 'No accounts found',
  searchInProgress: 'Search in progress...',
  countersAndLimits: {
    _: 'Counters and limits',
    counter: 'Counter',
    currentValue: 'Current value',
    limitValue: 'Limit value',
    purchasesToday: 'Purchases today',
    purchasesThisMonth: 'Purchases this month',
    refundsToday: 'Refunds today',
    refundsThisMonth: 'Refunds this month',
    businesses: {
      VELOCITY_CONTROL: 'Purchase acceptance per day',
    },
    individuals: {
      VELOCITY_CONTROL: 'Spending per month',
    },
  },
  linkedAccounts: 'Linked accounts',
  shared: 'SHARED',
  owner: 'Owner',
  productTemplateFallback:
    'Product template for this account is missing. No current balance/counters/limits information is available. Account can not be used to run transactions.',
  accountNumber: 'Account number',
  currency: 'Currency',
  status: {
    _: 'Status',
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    CLOSED: 'Closed',
  },
};
